import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hasBrandInformation: false,
  promptDismissed: false,
  analyzing: false,
  resetContextPending: false,
};

const brandDiscoverySlice = createSlice({
  name: 'brandDiscovery',
  initialState,
  reducers: {
    initializeBrandDiscovery: (state, action) => {
      state.hasBrandInformation = !!action.payload?.hasBrandInformation;
      state.promptDismissed = false;
      state.analyzing = false;
      state.resetContextPending = false;
    },
    dismissBrandPrompt: (state) => {
      state.promptDismissed = true;
      state.analyzing = false;
    },
    setBrandAnalyzing: (state, action) => {
      state.analyzing = !!action.payload;
    },
    markBrandAnalyzed: (state) => {
      state.hasBrandInformation = true;
    },
    queueBrandContextReset: (state) => {
      state.resetContextPending = true;
    },
    consumeBrandContextReset: (state) => {
      state.resetContextPending = false;
    },
    resetBrandPromptState: (state) => {
      state.promptDismissed = false;
      state.analyzing = false;
      state.resetContextPending = false;
    },
  },
});

export const {
  initializeBrandDiscovery,
  dismissBrandPrompt,
  setBrandAnalyzing,
  markBrandAnalyzed,
  queueBrandContextReset,
  consumeBrandContextReset,
  resetBrandPromptState,
} = brandDiscoverySlice.actions;

export default brandDiscoverySlice.reducer;
